
export const LANGUAGES = {
  default: 'en-US',
  'en-US': 'en-US'
}